import React, { useState, useEffect } from "react";
import styles from "./style.module.scss";
import version from "../../version.json";
import { Tooltip } from "react-tooltip";
import { BACKEND_SERVER_URL } from "../../config";
import runTimeVars from "../../runTimeVars";

function Version() {
  const [backendVersion, setBackendVersion] = useState<string | null>(null);

  useEffect(() => {
    // Fetch the backend version from the API
    fetch(`${BACKEND_SERVER_URL}/api/version`, { method: "GET" })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Fetching backend version failed");
        }
        return response.json();
      })
      .then((data) => {
        setBackendVersion(data.version);
      })
      .catch((error) => {
        console.error("Fetching backend version failed:", error);
      });
  }, []);

  const versionTooltip = backendVersion
    ? backendVersion !== "dev"
      ? `v${backendVersion}`
      : "dev"
    : null;

  return (
    <>
      <Tooltip id="backendVersionTooltip" />
      <div
        className={styles.version}
        data-tooltip-id="backendVersionTooltip"
        data-tooltip-content={versionTooltip}
        data-tooltip-placement="bottom"
      >
        {process.env.NODE_ENV === "production"
          ? `${runTimeVars.environmentName} v${version.version}`
          : "dev"}
      </div>
    </>
  );
}

export default Version;
